import Component from "@glimmer/component"
import type { PlanbookSummary } from "@shared/models/planbook"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"

interface Sig {
  Args: {
    planbookId: string
  }
  Blocks: {
    default: [model: FindDoc<"planbook-summary", PlanbookSummary>]
  }
}

export default class PlanbookSummaryProviderComponent extends Component<Sig> {
  @use model = new FindDoc(() => ["planbook-summary", this.args.planbookId])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    PlanbookSummaryProvider: typeof PlanbookSummaryProviderComponent
  }
}
